module.exports = __webpack_public_path__ + "static/media/5.e421a2b3.svg";